/*******************************************************************************
  LocationBehavior.js

  Author: Advait
*******************************************************************************/

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSite, updateSite as updateSiteInStore } from "../store/siteSlice";
import { updateLocationBehavior } from "../apihelpers/graphqlhelpers";
import "../index.css";
import { showNotification } from "../components/helper/notification";

const actions = [
  { key: "No Action", value: "NONE" },
  { key: "Rotate 360 Degrees", value: "360" },
];

//***************************************************************************
// This class handles security patrol location behavior values.
//***************************************************************************
function LocationBehavior() {
  const dispatch = useDispatch();
  const selectedSite = useSelector(selectSite);
  const [wait_time, setWait_time] = useState(
    selectedSite ? selectedSite.securityRound_wait_time : 0
  );
  const [action, setAction] = useState(
    selectedSite ? selectedSite.securityRound_action : "NONE"
  );
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  //***************************************************************************
  // Update the values to the database and notify parent on save button
  //***************************************************************************
  async function handleSaveBehavior(e) {
    setSaveButtonDisabled(true);
    try {
      const response = await updateLocationBehavior(selectedSite.id, action, wait_time);
      showNotification(response);
      dispatch(updateSiteInStore(response.data.updateSite));
    } catch {
      showNotification();
    }
  }

  //***************************************************************************
  // render the UI
  //***************************************************************************
  return (
    <div className="individualContainer">
      <table className="individualContainerTable">
        <tbody>
          <tr>
            <td className="individualContainerTitleColumn" valign="top">
              <h4 className="individualContainerTitleHeading">Location Behavior</h4>
            </td>
            <td>
              <table>
                <tbody>
                  <tr>
                    <td className="subTitleColumnLocationBehavior">
                      <h6 className="subTitleColumnLocationBehaviorH6">
                        Action to Take at Each Location
                      </h6>
                    </td>
                    <td valign="top">
                      <select
                        id="action"
                        name="action"
                        style={{ width: "175px" }}
                        className="inputField"
                        value={action}
                        onChange={(e) => {
                          setSaveButtonDisabled(false);
                          setAction(e.target.value);
                        }}
                      >
                        {actions.map((action) => (
                          <option key={action.value} value={action.value}>
                            {action.key}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td className="subTitleColumnLocationBehavior">
                      <h6
                        className="subTitleColumnLocationBehaviorH6"
                        style={{ paddingTop: "5px" }}
                      >
                        Wait Time at Each Location After Performing the Action
                      </h6>
                    </td>
                    <td valign="top">
                      <input
                        className="inputField"
                        type="number"
                        style={{ width: "55px" }}
                        min={0}
                        max={999}
                        value={wait_time}
                        onChange={(e) => {
                          setSaveButtonDisabled(false);
                          setWait_time(e.target.value);
                        }}
                      />
                      &ensp;second(s)
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td className="individualContainerTitleColumn" valign="top"></td>
            <td style={{ padding: "0 0 15px 0" }}>
              <button
                className="saveButton"
                onClick={handleSaveBehavior}
                disabled={saveButtonDisabled}
              >
                Save
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
export default LocationBehavior;
